import classNames from "classnames";
import React from "react";
import { PendingStatus } from "../pendingStatus/pendingStatus";
import sharedStyles from "../styles.css";
import styles from "./adviserNameSummary.css";

export interface Props {
  firstName?: string;
  lastName?: string;
  email: string;
  className?: string;
}
export const PendingAdviserNameSummary = ({ firstName, lastName, email, className }: Props) => {
  return (
    <div className={classNames(sharedStyles.container, styles.container, className)}>
      <div className={styles.avatar} />
      <div className={styles["name-and-email"]}>
        <div className={classNames(sharedStyles["font-content"], styles.name)}>
          <p>{firstName + " " + lastName}</p>
          <PendingStatus inviteeEmail={email} />
        </div>
        <div className={classNames(sharedStyles["font-description"], styles.email)}>{email}</div>
      </div>
    </div>
  );
};
